module.exports = __webpack_public_path__ + "img/dropdown-search-honda.4c923aa3.png";